import React from 'react';
import PropTypes from 'prop-types';

export default class AccordionItem extends React.PureComponent {
    static propTypes = {
        /** Expected to be one AccordionHeading and one AccordionContent */
        children: PropTypes.node.isRequired,

        /** click handler from Accordion */
        handleHeadingClick: PropTypes.func,

        /** Aligns the contents with the heading text instead of the icon. */
        hasIndentedBody: PropTypes.bool,

        /** The heading style for all items. */
        headingAppearance: PropTypes.oneOf(['h4', 'h5', 'h5Caps', 'h6']),

        /** The heading tag to use for all items. */
        headingLevel: PropTypes.number,

        /** id used to construct the aria relationship between the heading and
         * content. It's only necessary to provide an id if there's more than
         * one Accordion on the page.  */
        id: PropTypes.string,

        /** If the item is controlled by Accordion or if it manages its own state */
        isControlled: PropTypes.bool,

        /** If the contents are expanded */
        isExpanded: PropTypes.bool
    };

    static defaultProps = {
        handleHeadingClick: undefined,
        hasIndentedBody: true,
        headingAppearance: 'h6',
        headingLevel: 3,
        isControlled: false,
        isExpanded: false
    };

    state = {
        isExpanded: this.props.isExpanded || false
    };

    handleHeadingClick = (e) => {
        const { isControlled, handleHeadingClick } = this.props;

        e.preventDefault();

        if (isControlled) {
            handleHeadingClick();
        }
        else {
            this.setState((prevState) => {
                return {
                    isExpanded: !prevState.isExpanded
                };
            });
        }
    }

    render() {
        const {
            children,
            id,
            isControlled,
            hasIndentedBody,
            headingLevel,
            headingAppearance,
            isExpanded
        } = this.props;

        const clonedChildren = React.Children.map(children, (child) => {
            const headingProps = {
                handleHeadingClick: this.handleHeadingClick,
                headingAppearance,
                headingLevel,
                id,
                isExpanded: isControlled ? isExpanded : this.state.isExpanded
            };

            const bodyProps = {
                id,
                hasIndentedBody,
                isExpanded: isControlled ? isExpanded : this.state.isExpanded
            };

            return React.cloneElement(
                child,
                child.type.displayName === 'AccordionHeading'
                    ? headingProps
                    : bodyProps
            );
        });

        return (
            <div className="sarsa-accordion-item" data-component="AccordionItem">
                {clonedChildren}
            </div>
        );
    }
}